const sceneId = "1fej7kvt";
const prefix = "doryjw";

/** 阿里防水墙v2 */
export function getCaptchaV2(domId, btnId) {
  const dom = document.getElementById(domId);
  if (!dom) {
    return Promise.reject(`找不到ID：${domId}`);
  }
  dom.innerHTML = "";
  return new Promise((resolve, reject) => {
    try {
      let captchaInstance;
      initAliyunCaptcha({
        SceneId: sceneId, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: prefix, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: "embed", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: "#" + domId, // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: "#" + btnId, // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        immediate: true,
        // 业务请求(带验证码校验)回调函数，无需修改
        captchaVerifyCallback: captchaVerifyParam => {
          console.log("captchaVerifyParam", captchaVerifyParam);
          resolve(captchaVerifyParam);
        },
        // 业务请求结果回调函数，无需修改
        onBizResultCallback: params => {
          console.log("onBizResultCallback", params);
        },
        getInstance: instance => (captchaInstance = instance), // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 380,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    } catch (error) {
      console.error("验证码加载失败", error);
      reject(error);
    }
  });
}
